import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/unauthorized" replace />;
  }

  try {
    const payload = jwtDecode(token);
    if (!payload.exp || payload.exp * 1000 <= Date.now()) {
      localStorage.removeItem('token');
      return <Navigate to="/" replace />;
    }
  } catch {
    localStorage.removeItem('token');
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
